import * as React from 'react'
import { BehaviorSubject } from 'rxjs'
import { FirebaseContext, ModelContext } from './Ctx'
import Model from './Model'
import RenderSubject from './RenderSubject'
import { subjectArrayToArray } from './utils'
import * as firebase from 'firebase'
import { SCREEN } from './Srnka'

interface IChangingScreen {
	changeScreen: (screen: string) => void
}
interface IProps extends IChangingScreen {
	model: Model
	firebase: typeof firebase
	data: any
}
interface IState {
	questions: BehaviorSubject<firebase.firestore.DocumentSnapshot[]> | null
	showIntro: boolean
	checked: number | null
	result: null | Result
	answeringId: null | string
}
interface IAnswer {
	label: string
	correct: boolean
}
interface IQuestion {
	question: string
	from: Date
	until: Date
	answers: IAnswer[]
	award?: number
}

enum Result {
	Correct,
	Wrong
}

const Materials = () => (
	<p>
		Zajímá tě proč? Podívej se do{' '}
		<a
			target="_blank"
			href="https://drive.google.com/drive/folders/19HQikpsN378Ju_Hc-hHfPjlgqLWYdqnw?usp=sharing"
		>
			materiálů
		</a>
		!
	</p>
)

class Quiz extends React.PureComponent<IProps, IState> {
	public state: IState = {
		checked: null,
		showIntro: true,
		questions: null,
		result: null,
		answeringId: null
	}

	public render() {
		return (
			<RenderSubject<firebase.firestore.QuerySnapshot>
				subject={this.props.model.getCollectionByPath(`questions`)}
			>
				{(snap: firebase.firestore.QuerySnapshot | null) => {
					return (
						<RenderSubject<firebase.firestore.QuerySnapshot>
							subject={this.props.model.getCollectionByPath(
								`/srnky/${this.props.data.id}/answered`
							)}
						>
							{(
								answeredSnap: firebase.firestore.QuerySnapshot | null
							) => {
								if (snap === null || answeredSnap === null)
									return null
								const questionsSnaps: firebase.firestore.QueryDocumentSnapshot[] = snap.docs
									.filter(snap => {
										const d = snap.data() as IQuestion
										return (
											d.from.getTime() < Date.now() &&
											Date.now() < d.until.getTime()
										)
									})
									.filter(
										snap =>
											!answeredSnap.docs.find(
												a =>
													a.data().question.id ===
													snap.id
											)
									)
								const questions = questionsSnaps.map(
									a => a.data() as IQuestion
								)

								// Result
								if (this.state.result !== null) {
									const reason = null
									if (this.state.result === Result.Correct) {
										return (
											<div className="QuizResult">
												<div>
													<p>Správně</p>
													<Materials />
												</div>
												{reason && <div>{reason}</div>}
												<button
													className="Button"
													onClick={() =>
														this.setState({
															result: null,
															answeringId: null
														})
													}
												>
													Zpět
												</button>
											</div>
										)
									} else {
										return (
											<div className="QuizResult QuizResult-wrong">
												<div>
													<p>Špatně</p>
													<Materials />
												</div>
												{reason && <div>{reason}</div>}
												<button
													className="Button"
													onClick={() =>
														this.setState({
															result: null,
															answeringId: null
														})
													}
												>
													Zpět
												</button>
											</div>
										)
									}
								}

								const askingSnap = questionsSnaps.find(
									s => s.id === this.state.answeringId
								)
								const question =
									askingSnap &&
									(askingSnap.data() as IQuestion)

								// Intro
								return this.state.showIntro && !askingSnap ? (
									questions && (
										<>
											<div className="QuizIntroScreen">
												<div>
													Máš {questions.length}{' '}
													dostupných otázek
												</div>
												<div>
													<button
														className="Button"
														onClick={() => {
															const toAsk = questionsSnaps.find(
																() => true
															)
															if (
																toAsk &&
																toAsk.exists
															) {
																this.setState({
																	showIntro: false,
																	checked: null,
																	answeringId:
																		toAsk.id
																})
															}
														}}
														disabled={
															questions.length < 1
														}
													>
														Jsem připraven!
													</button>
												</div>
											</div>
											<button
												className="LeftIconButton"
												onClick={e => {
													e.preventDefault()
													this.props.changeScreen(
														SCREEN.FIELD
													)
												}}
												// style={{ color: 'white' }}
											>
												<i
													className="fa fa-tree"
													aria-hidden="true"
												/>
											</button>
										</>
									)
								) : (
									// Question
									<div className="QuizScreen">
										<h2 className="Question">
											{question.question}
										</h2>
										<div className="Options">
											{question.answers.map(
												(answer, i) => (
													<label
														key={i}
														className={`Option ${
															i ===
															this.state.checked
																? 'Option-selected'
																: ''
														}`}
													>
														<input
															type="radio"
															name="answer"
															checked={
																this.state
																	.checked ===
																i
															}
															onChange={e =>
																this.setState({
																	checked: i
																})
															}
															className="Option_input"
														/>
														{answer.label}
													</label>
												)
											)}
										</div>
										<div className="Submit_wrap">
											<button
												onClick={async () => {
													const checkedIndex = this
														.state.checked
													const chosen =
														question.answers[
															checkedIndex
														]
													if (chosen.correct) {
														const srnkaRef = this.props.firebase
															.firestore()
															.collection('srnky')
															.doc(
																this.props.data
																	.id
															)

														const srnka = (await srnkaRef.get()).data()
														await srnkaRef.update({
															money:
																srnka.money +
																(question.award ||
																	25)
														})
														this.setState({
															showIntro: true,
															checked: null,
															result:
																Result.Correct
														})
													} else {
														this.setState({
															showIntro: true,
															checked: null,
															result: Result.Wrong
														})
													}
													const answeredRef = this.props.firebase
														.firestore()
														.collection(
															`/srnky/${
																this.props.data
																	.id
															}/answered`
														)
													await answeredRef.add({
														timestamp: new Date(),
														question:
															askingSnap.ref,
														correct: chosen.correct,
														chosenLabel:
															chosen.label,
														chosenIndex: checkedIndex
													})
												}}
												className="Submit"
												disabled={
													this.state.checked === null
												}
											>
												Odeslat
											</button>
										</div>
									</div>
								)
							}}
						</RenderSubject>
					)
				}}
			</RenderSubject>
		)
	}
}

export default props => (
	<ModelContext.Consumer>
		{model => (
			<FirebaseContext.Consumer>
				{firebase => (
					<Quiz {...props} firebase={firebase} model={model} />
				)}
			</FirebaseContext.Consumer>
		)}
	</ModelContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/Quiz.tsx